/**
 * useReglasHorario — Hook que suscribe a la subcolección
 * `salas/{salaId}/horarios` y devuelve las reglas en tiempo real.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { ReglaHorario } from '../utils/horariosSalaUtil';

export function useReglasHorario(salaId: string | undefined): {
  reglas: ReglaHorario[];
  loading: boolean;
} {
  const [reglas, setReglas] = useState<ReglaHorario[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!salaId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setReglas([]);
      setLoading(false);
      return;
    }
    const ref = collection(db, `salas/${salaId}/horarios`);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const items: ReglaHorario[] = snap.docs.map((d) => ({
          id: d.id,
          ...(d.data() as Omit<ReglaHorario, 'id'>),
        }));
        setReglas(items);
        setLoading(false);
      },
      () => setLoading(false),
    );
    return () => unsub();
  }, [salaId]);

  return { reglas, loading };
}
